import React from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                height: '40px',
                backgroundColor: 'rgba(20, 36, 52, 0.05)', // #142434 with 5% opacity
                borderBottom: '0.5px solid #142434',
                px: 2,
            }}
        >
            {items.map((item, index) => {
                const isLast = index === items.length - 1;
                return (
                    <Box key={item.title} sx={{ display: 'flex', alignItems: 'center' }}>
                        {isLast ? (
                            <Typography
                                sx={{
                                    fontFamily: 'PT Sans, sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    color: '#142434',
                                }}
                            >
                                {item.title}
                            </Typography>
                        ) : (
                            <MuiLink
                                component={Link}
                                to={item.path}
                                sx={{
                                    fontFamily: 'PT Sans, sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    color: '#142434',
                                    textDecoration: 'none',
                                    '&:hover': { textDecoration: 'underline' },
                                }}
                            >
                                {item.title}
                            </MuiLink>
                        )}
                        {!isLast && (
                            <Typography
                                sx={{
                                    fontFamily: 'PT Sans, sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    color: '#142434',
                                    mx: 1,
                                }}
                            >
                                &gt;
                            </Typography>
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default Breadcrumb;
